import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import { BASE_LEAVE_URL, BASE_AUTOCOMPLETE_URL, BASE_URL } from '../apiConfig';

const fetchEmployeeLeaves = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/enquiry`,
    payload,
  );
  return response;
};

const fetchEmployeeLeaveTypes = async () => {
  const response = await apiClient.get(`${BASE_URL}${BASE_LEAVE_URL}/types`);
  return response;
};

const fetchEmployeeLeavesColumn = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-table-column-values`,
    payload,
  );
  return response;
};

const fetchDelegateEmployerAutoComplete = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-delegate-approval`,
    payload,
  );
  return response;
};

const applyLeave = async formData => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/apply`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response;
};

const fetchTimeOffHistory = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/time-off-history`,
    payload,
  );
  return response;
};

const fetchVacationBalance = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_LEAVE_URL}/vacation-balance`,
  );
  return response[0];
};

const fetchDepartmentLeaveStatus = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/department-leave-status`,
    payload,
  );
  return response;
};

const fetchLeaveByTransactionId = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/trans`,
    payload,
  );
  return response;
};

const fetchVacationExtraOrUsedBalance = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/vacation-balance/extra-or-used`,
    payload,
  );
  return response;
};

export {
  fetchEmployeeLeaves,
  fetchEmployeeLeaveTypes,
  fetchEmployeeLeavesColumn,
  fetchDelegateEmployerAutoComplete,
  applyLeave,
  fetchTimeOffHistory,
  fetchVacationBalance,
  fetchDepartmentLeaveStatus,
  fetchLeaveByTransactionId,
  fetchVacationExtraOrUsedBalance,
};
